import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, roles }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="w-8 h-8 border-2 border-accent border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname)}`} replace />;
  }

  if (roles && roles.length > 0 && !roles.includes(user?.role)) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen w-full bg-[#0f1623] px-4 text-center">
        <h2 className="text-2xl font-bold text-white mb-2">Access restricted</h2>
        <p className="text-gray-400 max-w-md text-sm mb-6">
          This page is only available to authorized leadership accounts. If you believe you should
          have access, ask an administrator to grant your account the right role.
        </p>
        <a href="/" className="text-sm font-medium text-white underline underline-offset-4 hover:text-gray-300">
          Return home
        </a>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
